import { useFieldInfo, useTsController } from "@ts-react/form";
import { useId } from "react";
import { Fieldset, Label, type SwitchProps, Theme } from "tamagui";
import { CustomSwitch } from "../CustomSwitch";
import { FormError } from "./FormError";
import { useFormFieldOptions } from "./FormFieldOptionsProvider";
export const BooleanSwitchField = (props: Pick<SwitchProps, "size" | "native">) => {
  const {
    field,
    error,
    formState: {
      isSubmitting
    }
  } = useTsController<boolean>();
  const {
    label,
    isOptional
  } = useFieldInfo();
  const {
    hideOptionalLabel
  } = useFormFieldOptions();
  const id = useId();
  const inputId = `${id}_boolean_switch_input`;
  const disabled = isSubmitting;
  return <Theme name={error ? "red_alt2" : "granted"} forceClassName data-sentry-element="Theme" data-sentry-component="BooleanSwitchField" data-sentry-source-file="BooleanSwitchField.tsx">
      <Fieldset ai="flex-start" data-sentry-element="Fieldset" data-sentry-source-file="BooleanSwitchField.tsx">
        {label ? <Label htmlFor={inputId} size={props.size || "$3"} pb="$1" pl={0}>
            {label}
            {isOptional && !hideOptionalLabel ? ` (Optional)` : null}
          </Label> : null}
        <CustomSwitch disabled={disabled} checked={field.value} onCheckedChange={checked => field.onChange(checked)} ref={field.ref} id={inputId} key={inputId} opacity={1} size="$3.5" {...props} data-sentry-element="CustomSwitch" data-sentry-source-file="BooleanSwitchField.tsx">
          <CustomSwitch.Thumb data-sentry-element="CustomSwitch.Thumb" data-sentry-source-file="BooleanSwitchField.tsx" />
        </CustomSwitch>
        <FormError errorMessage={error?.errorMessage} data-sentry-element="FormError" data-sentry-source-file="BooleanSwitchField.tsx" />
      </Fieldset>
    </Theme>;
};